import { FunctionComponent } from 'react';

import { Grid as RadixGrid, GridProps } from '@radix-ui/themes';

export const Grid: FunctionComponent<GridProps> = (props: GridProps) => {
  return <RadixGrid {...props} />;
};
